import { render, staticRenderFns } from "./Cyberswitch.vue?vue&type=template&id=45c7d6f1&scoped=true"
import script from "./Cyberswitch.vue?vue&type=script&lang=ts"
export * from "./Cyberswitch.vue?vue&type=script&lang=ts"
import style0 from "./Cyberswitch.vue?vue&type=style&index=0&id=45c7d6f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c7d6f1",
  null
  
)

export default component.exports